"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "阶段名称",
        prop: "stageName",
        isShow: true,
        width: "100"
      }, {
        name: "所属项目",
        prop: "matchId",
        isShow: true,
        width: "150",
        isFormats: true
      }, {
        name: "开始时间",
        prop: "beginTime",
        isShow: true,
        width: "150"
      }, {
        name: "结束时间",
        prop: "endTime",
        isShow: true,
        width: "150"
      }],
      funBtns: [{
        size: "small",
        click: "dels",
        icon: "el-icon-delete",
        name: "批量删除",
        type: "danger"
      }, {
        size: "small",
        click: "save",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "编辑",
        class: "edit",
        option: "modify",
        span: 2
      }, {
        name: "组别设置",
        class: "editor",
        option: "editGroup",
        span: 4
      }, {
        name: "项目单位设置",
        class: "editor",
        option: "editEdu",
        span: 4
      }, {
        name: "项目阶段设置",
        class: "editor",
        option: "editStage",
        span: 4,
        field: {
          name: "groupCount",
          value: 0,
          then: "greater"
        }
      }, {
        name: "删除",
        class: "delet",
        option: "deleteById",
        span: 2
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      }
    };
  },
  methods: {
    listBureau: function listBureau() {},
    morePublishout: function morePublishout() {},
    morePublish: function morePublish() {},
    dels: function dels() {},
    // 新增
    save: function save() {
      this.$router.push("/object/object-add");
    },
    editBureau: function editBureau() {},
    handleSelectionChange: function handleSelectionChange() {},
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getLinkList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getLinkList();
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};